import { VendorPaymentMethodEnum } from "@finway-group/shared/lib/models/vendorPayment/vendorPayment.enums"
import { type VendorPayment, type VendorPaymentProposal } from "@finway-group/shared/lib/models/vendorPayment/vendorPayment.interface"
import axios from "axios"
import { FileService } from "~Shared/services/file.service"
import { openWindowInNewTab } from "~Shared/utils/window.utils"
import { handleWebformResponse } from "./bank.service"

const MODEL = "vendor-payments"

export interface CreateVendorPaymentData {
    expenseIds: Array<string>
    method: VendorPaymentMethodEnum
    accountId?: string
    executionDate?: string
    shouldBypassAmountCheck?: boolean
}

export const VendorPaymentService = {
    fetchProposals: async () => {
        const { data } = await axios.get<Array<VendorPaymentProposal>>(`/${MODEL}/proposals`)
        return data
    },
    fetchVendorPayment: async (id: string) => {
        const { data } = await axios.get<VendorPayment>(`/${MODEL}/${id}`)
        return data
    },
    createVendorPayment: async (paymentData: CreateVendorPaymentData) => {
        const { data } = await axios.post<{ vendorPayment: VendorPayment; webForm?: { webFormUrl?: string }; fileUrl?: string }>(`/${MODEL}`, paymentData)
        if (data.webForm) {
            handleWebformResponse({ data: data.webForm } as never)
        }
        if (data.fileUrl) {
            FileService.downloadFileAsSignedUrl(data.fileUrl)
        }
        return data.vendorPayment
    },
    /** @returns the expense numbers that could not be marked as paid */
    markAsPaid: async (paymentData: Omit<CreateVendorPaymentData, "method">) => {
        const { data } = await axios.post<{ filteredOutExpenseNumbers: Array<number> }>(`/${MODEL}`, { ...paymentData, method: VendorPaymentMethodEnum.MARK_AS_PAID })
        return data.filteredOutExpenseNumbers ?? []
    },
    /** @returns the expense numbers that could not be marked as paid */
    markExportedAsPaid: async (id: string) => {
        const { data } = await axios.post<{ filteredOutExpenseNumbers: Array<number> }>(`/${MODEL}/${id}/mark-as-paid`)
        return data.filteredOutExpenseNumbers ?? []
    },
    downloadAvis: async (id: string) => {
        const { data } = await axios.get<{ url: string }>(`/${MODEL}/${id}/avis`)
        openWindowInNewTab({ url: data.url, target: "_self" })
    },
    cancelVendorPayment: async (id: string) => {
        const { data } = await axios.post<VendorPayment>(`/${MODEL}/${id}/cancel`)
        return data
    },
}
